function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import objectReduce from 'fast-loops/lib/objectReduce';

export default function mapValueToMediaQuery() {
  var queryValueMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mapper = arguments[1];

  return objectReduce(queryValueMap, function (style, value, query) {
    if (typeof mapper === 'string') {
      style[query] = _defineProperty({}, mapper, value);
    } else {
      style[query] = mapper(value);
    }

    return style;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-tools/es/mapValueToMediaQuery.js
// module id = 140
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38